requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('popup-module')) {
      class PopupModule extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {

          if (this.dataset.insertAfterBody && this.dataset.insertAfterBody !== 'done') {
            const main = this.closest('#MainContent');

            if (main) {
              this.dataset.insertAfterBody = 'done';
              this.connectedCallback();
              main.after(this.closest('.shopify-section'));
              return;
            }
          }

          this.timer = this.dataset.cookiesLife;
          this.edgeLimit = 70;

          this.animationDuration = parseInt(window.getComputedStyle(this).getPropertyValue(this.dataset.durationVariable || '--popups-transition-duration'));

          this.closeButton = this.querySelectorAll('[data-popup-close-button], .modal-overlay');
          this.onEscapeKeyHandler = this.onEscapeKey.bind(this);

          if (document.body.classList.contains('popup-blocked-all') && !this.dataset.blockAll) {
            window.addEventListener('popupsUnblocked', () => this.init(), {
              once: true
            });
          } else {
            this.init();
          }
        }

        init() {
          this.dataset.showOnMobile === 'false' ? themeBase.viewportFunction(true, this.onLoad) : this.onLoad();
        }

        onEscapeKey(event) {
          if (event.code.toUpperCase() === 'ESCAPE') {
            document.removeEventListener('keyup', this.onEscapeKeyHandler);
            this.hide();
          }
        }

        show(event) {
          if (event) event.preventDefault();
          if (this.checkCookies() || this.classList.contains('popup-module--open')) return;

          this.classList.add('popup-module--preopen');

          lazyImages.checkImageLoading(this, () => {
            window.scrollTo(0, window.scrollY);

            const open = () => {
              themeBase.requestIdleCallback(() => {
                this.classList.add('popup-module--open');
                setTimeout(() => window.dispatchEvent(new CustomEvent('popupToogled')));

                if (this.dataset.bodyClassname) document.body.classList.add(this.dataset.bodyClassname);
                if (this.dataset.escapeKey) {
                  document.addEventListener('keyup', this.onEscapeKeyHandler);
                }

                this.focus();

              });
            };

            if (this.dataset.blockAll) document.body.classList.add('popup-blocked-all');
            if (this.dataset.scrollTop) window.scrollTo(0, 0);
            if (this.dataset.freeze || (themeBase.isMobile && this.dataset.freezeMobile)) {
              setTimeout(() => {
                this.wasFreeze = true;
                themeBase.freezeScroll({
                  additionalClass: 'popup-module-visible'
                });

                themeBase.checkWindow();
                open();
              }, 150);
            } else {
              open();
            }
          }, this.dataset.ignoreLazyImages);
        }

        hide(event) {
          if (event) event.preventDefault();


          themeCookies.setWithTimer(this.timer, this.dataset.cookiesName, 'off');
          this.classList.add('popup-module--close');

          if (this.dataset.bodyClassname) document.body.classList.remove(this.dataset.bodyClassname);

          setTimeout(() => {
            this.classList.remove('popup-module--open', 'popup-module--close', 'popup-module--preopen');

            if ((this.dataset.freeze || this.wasFreeze) && !document.querySelectorAll('.popup-module--open:not(.popup-module--close)[data-freeze]').length) {
              themeBase.unfreezeScroll({
                additionalClass: 'popup-module-visible'
              });
              this.wasFreeze = false;
            }
            if (this.dataset.blockAll) {
              document.body.classList.remove('popup-blocked-all');
              window.dispatchEvent(new CustomEvent('popupsUnblocked'));
            }
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('popupToogled'));
              this.dispatchEvent(new CustomEvent('popupClosed'));
            }, 10);
          }, this.animationDuration);
        }

        checkCookies() {
          return this.dataset.cookiesName !== undefined && themeCookies.get(this.dataset.cookiesName) === 'off' && window.location.href.indexOf(this.dataset.urlCall) === -1;
        }

        onLoad() {
          if (this.checkCookies()) return;

          if (this.dataset.showTrigger === 'delay') {
            setTimeout(() => this.show(), (this.dataset.delay || 0) * 1000);
          } else if (this.dataset.showTrigger === 'exit_intent') {
            let enableHandler = false;
            const mousemoveHandler = event => {
              if (!enableHandler && (event.clientX > this.edgeLimit && event.clientX < window.innerWidth - this.edgeLimit && event.clientY > this.edgeLimit && event.clientY < window.innerHeight - this.edgeLimit)) {
                enableHandler = true;
              } else if (enableHandler && (event.clientX < this.edgeLimit || event.clientX > window.innerWidth - this.edgeLimit || event.clientY < this.edgeLimit || event.clientY > window.innerHeight - this.edgeLimit)) {
                window.removeEventListener('mousemove', mousemoveHandler);
                this.show();
              }
            };

            window.addEventListener('mousemove', mousemoveHandler);
          } else if (this.dataset.showTrigger === 'copy_to_clipboard') {
            window.addEventListener('copy', () => this.show());
          }

          this.closeButton.forEach(button => button.addEventListener('click', event => this.hide(event)));
        }
      }

      customElements.define('popup-module', PopupModule);

      class PopupOpener extends HTMLElement {
        constructor() {
          super();

          this.button = this.querySelector('button, a');
          this.button?.addEventListener('click', (event) => {
            this.open(event);
          });
        }

        open(event) {
          const popup = document.querySelector(this.getAttribute('data-popup'));

          if (popup) {
            event.preventDefault();
            popup.show(event);
          }
        }
      }

      customElements.define('popup-opener', PopupOpener);

      scriptController.scripts.push('popup-module.js');
    }
  });
});